import { MAX_DESCRIPTION_LENGTH } from "./document.js";
/** 22 base64url characters: `randomBytes(16).toString("base64url")`. */
export const SHARE_TOKEN_PATTERN = /^[A-Za-z0-9_-]{22}$/;
/**
 * THE PRICE AN ITEM IS ANNOUNCED AT, on its page and on its WhatsApp card:
 * the cheapest variant's, «from» it only when the variants' prices differ --
 * three colours at one price cost that price, not «Desde» it. Null without a
 * variant.
 */
export function itemPriceOf(variants) {
    if (variants.length === 0)
        return null;
    const prices = variants.map((variant) => variant.priceCents);
    const cents = Math.min(...prices);
    return { cents, from: prices.some((price) => price !== cents) };
}
/**
 * The item's page title, «Recarga de gas · Frío Total», as the profile's is
 * «Frío Total · Taller …» (`profileTitle`): one function for the Worker's
 * `<title>` and the page's own.
 */
export function itemTitle(view) {
    return `${view.item.name} · ${view.business.name}`;
}
/**
 * WHAT IS ASKED FOR, FROM AN ITEM'S PAGE: «Recarga de gas
 * refrigerante · Gas R-32» -- the item and the variant chosen, the way the
 * WhatsApp message names it, and what «Pedir servicio» writes in «¿Qué
 * necesitas?». Never longer than a request may say (`MAX_DESCRIPTION_LENGTH`,
 * the request's own limit): the visitor would meet a refusal she did not write.
 */
export function itemWishText(itemName, variantName) {
    const variant = variantName?.trim() ?? "";
    const text = variant === "" ? itemName.trim() : `${itemName.trim()} · ${variant}`;
    return text.slice(0, MAX_DESCRIPTION_LENGTH);
}
